import { render, staticRenderFns } from "./UMLTextElement.vue?vue&type=template&id=65d47c28&scoped=true&"
import script from "./UMLTextElement.vue?vue&type=script&lang=js&"
export * from "./UMLTextElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d47c28",
  null
  
)

export default component.exports